enum UserFilterEnum {
    Company = 'Company',
    Department = 'Department',
    DateInService = 'DateInService',
    Location = 'Location',
}

export default UserFilterEnum;
